import axios from 'axios';

import {
  axiosHeader,
  getV1RootUrl,
  getV2RootUrl,
  publicAxiosHeader,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';

export const authenticateForFullSteamWallet = () =>
  axios.post(
    `${getV2RootUrl()}/payment/fullsteam/club-signup/auth-digital-wallet`,
    {},
    publicAxiosHeaderV2()
  );

export const getClubSignupForSharing = (clubSignupId, customerId) => {
  if (customerId) {
    return axios.get(
      `${getV1RootUrl()}/club-signup/${clubSignupId}/for-sharing`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/for-sharing`,
    publicAxiosHeader()
  );
};

export const getClubSignup = (clubSignupId) =>
  axios.get(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/for-web`,
    publicAxiosHeader()
  );

export const getClubSignupV2 = (clubSignupId) =>
  axios.get(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/for-web`,
    publicAxiosHeaderV2()
  );

export const createClubSignup = (clubSignup) =>
  axios.post(`${getV1RootUrl()}/club-signup`, clubSignup, publicAxiosHeader());

export const updateClubSignup = (clubSignupId, clubSignup) =>
  axios.put(
    `${getV1RootUrl()}/club-signup/${clubSignupId}`,
    clubSignup,
    publicAxiosHeader()
  );

export const editVirtualSignUp = (clubSignupId, payload) =>
  axios.put(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/virtual`,
    payload,
    publicAxiosHeader()
  );

export const processClubSignup = (clubSignupId, payload) =>
  axios.put(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/process`,
    payload,
    publicAxiosHeader()
  );

export const processFullsteamClubSignup = (clubSignupId, payload) =>
  axios.post(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/fullsteam/process-payment-for-digital-wallet`,
    payload,
    publicAxiosHeaderV2()
  );

export const processPayStackClubSignup = (clubSignupId, tenderId) =>
  axios.put(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/process-from-pay-stack`,
    { tenderId },
    publicAxiosHeader()
  );
